import React, { useEffect, useState } from "react";
import { Usuario } from "../../../Models/Cadastros/Usuario/Usuario";
import InlineSearchComponent from "../../../Components/Forms/InlineSearchComponent";
import DropDownListComponent from "../../../Components/Forms/DropDownListComponent";
import TextFieldComponent from "../../../Components/Forms/TextFieldComponent";
import DropDownBooleanComponent from "../../../Components/Forms/DropDownBooleanComponent";
import UsuarioNaoConformidadePartial from "./UsuarioNaoConformidadePartial";

const UsuarioDadosTab = (props: any) => {
    const [usuario, setUsuario] = useState<any>(new Usuario());
    const [perfis, setPerfis] = useState<any[]>([]);
    const [showPainelNaoConformidade, setShowPainelNaoConformidade] = useState(false);

    const optionSelecaoValue = [
        { label: 'Sim', value: 1 },
        { label: 'Não', value: 2 },
        { label: 'Selecionados', value: 3 },
    ];

    useEffect(() => {
        setPerfis(props.perfis);
    }, [props.perfis]);

    useEffect(() => {
        setUsuario(props.usuario);
        setShowPainelNaoConformidade(usuario.email_nao_conformidade==3);
    }, [props.usuario]);

    function setEmailNaoConformidadeCallBack() {
        setShowPainelNaoConformidade(usuario.email_nao_conformidade==3);
    }
    
    return (
        <div className="row">
            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="Nome"
                    field='nome'
                    model={usuario} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    required
                    label="Sobrenome"
                    field='sobrenome'
                    model={usuario} />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownListComponent
                    label='Perfil'
                    required
                    options={perfis}
                    valueField='id'
                    textField='descricao'
                    model={usuario}
                    modelField='perfil_id' />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Celular"
                    field='celular'
                    model={usuario} />
            </div>

            <div className="col-md-6 mb-3">
                <TextFieldComponent
                    required
                    disabled={usuario.usuario_id > 0}
                    label="Nome Usuário"
                    field='nome_usuario'
                    model={usuario} />
            </div>

            <div className="col-md-6 mb-3">
                <TextFieldComponent
                    label="E-mail"
                    field='email'
                    model={usuario} />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='E-mail Ratc'
                    model={usuario}
                    modelField='email_ratc' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownListComponent
                    label='E-mail não Conformidade'
                    options={optionSelecaoValue}
                    valueField='value'
                    textField='label'
                    model={usuario}
                    modelField='email_nao_conformidade'
                    setValueEventCallBack={setEmailNaoConformidadeCallBack} />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Checklist'
                    model={usuario}
                    modelField='email_checklist' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='CNH Vencida'
                    model={usuario}
                    modelField='email_cnh_vencida' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Ver todas viagens'
                    model={usuario}
                    modelField='todas_viagens' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Ver todas Regras'
                    model={usuario}
                    modelField='todas_regras' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Mapa'
                    model={usuario}
                    modelField='mapa' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Prime'
                    model={usuario}
                    modelField='prime' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Aprovar Pesquisa'
                    model={usuario}
                    modelField='aprovar_pesquisa' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Finaliza Perda Sinal'
                    model={usuario}
                    modelField='finaliza_perda_sinal' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Menu Patio'
                    model={usuario}
                    modelField='menu_painel_eventos_logisticos' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Controle de Acesso'
                    model={usuario}
                    modelField='controla_tempo' />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Codigo Funcionário"
                    field='codigo_funcionario'
                    model={usuario} />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Pode Cancelar Viagem'
                    model={usuario}
                    modelField='pode_cancelar_viagem' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Pode Cancelar Checklist'
                    model={usuario}
                    modelField='pode_cancelar_checklist' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Somente Grid Checklist'
                    model={usuario}
                    modelField='somente_gridchecklist' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Grid Viagem Assistido'
                    model={usuario}
                    modelField='aba_assistido' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Grid Veículo'
                    model={usuario}
                    modelField='ver_grid_veiculo' />
            </div>

            <div className="col-md-6 mb-6">
                <DropDownBooleanComponent
                    label='Usuário Ativo'
                    model={usuario}
                    modelField='usuario_ativo' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Ver relatório Apontamento'
                    model={usuario}
                    modelField='ver_relatorio_apontamento' />
            </div>

            <div className="col-md-9 mb-9">
                <InlineSearchComponent
                    id='combo_empresa'
                    label='Empresa'
                    urlApi='buscaComboEmpresas'
                    valueField='id'
                    textField='nome_completo'
                    model={usuario}
                    modelField='empresa_id' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Painel de Performance'
                    model={usuario}
                    modelField='ver_painel_performance' />
            </div>

            <div className="col-md-9 mb-9">
                <TextFieldComponent
                    label="Link Painel de Performance"
                    field='link_painel_performance'
                    model={usuario} />
            </div>

            <div className="col-md-12 mb-12">
                <TextFieldComponent
                    label="Restringir IP(use ; para separar os IPs):"
                    field='ip'
                    model={usuario} />
            </div>

            {usuario.email_nao_conformidade==3 &&
                <div className="col-md-12 mb-12 mt-5">
                    <UsuarioNaoConformidadePartial usuario={usuario} />
                </div>
            }
        </div>
    );
}

export default UsuarioDadosTab;